import { GoogleGenAI, Type } from "@google/genai";

const ai = new GoogleGenAI({ apiKey: import.meta.env.VITE_GEMINI_API_KEY });

export interface SuggestedItem {
  name: string;
  description: string;
  tags: string[];
}

export async function analyzeContainerContents(base64Image: string): Promise<{ items: SuggestedItem[] } | null> {
  try {
    const response = await ai.models.generateContent({
      model: "gemini-3-flash-preview",
      contents: [{
        parts: [
          { inlineData: { mimeType: "image/jpeg", data: base64Image } },
          { text: "Analyze this photo of the contents of a storage tote or container. Identify all visible items. For each item provide a name, brief description, and 2-4 relevant tags. Return a JSON object with an 'items' array." },
        ],
      }],
      config: {
        responseMimeType: "application/json",
        responseSchema: {
          type: Type.OBJECT,
          properties: {
            items: {
              type: Type.ARRAY,
              items: {
                type: Type.OBJECT,
                properties: {
                  name: { type: Type.STRING },
                  description: { type: Type.STRING },
                  tags: { type: Type.ARRAY, items: { type: Type.STRING } },
                },
                required: ["name", "description", "tags"],
              },
            },
          },
          required: ["items"],
        },
      },
    });
    return JSON.parse(response.text || '{"items":[]}');
  } catch (error) {
    console.error("AI Container Analysis Error:", error);
    return null;
  }
}

export async function analyzeItemImage(base64Image: string) {
  try {
    const response = await ai.models.generateContent({
      model: "gemini-3-flash-preview",
      contents: [
        {
          parts: [
            {
              inlineData: {
                mimeType: "image/jpeg",
                data: base64Image,
              },
            },
            {
              text: "Analyze this image of an item to be stored in a container. Provide a name, a brief description, a category, and a list of 3-5 relevant tags. Return the result in JSON format.",
            },
          ],
        },
      ],
      config: {
        responseMimeType: "application/json",
        responseSchema: {
          type: Type.OBJECT,
          properties: {
            name: { type: Type.STRING },
            description: { type: Type.STRING },
            category: { type: Type.STRING },
            tags: {
              type: Type.ARRAY,
              items: { type: Type.STRING },
            },
          },
          required: ["name", "description", "category", "tags"],
        },
      },
    });

    return JSON.parse(response.text || "{}");
  } catch (error) {
    console.error("AI Analysis Error:", error);
    return null;
  }
}
